import React, { useEffect } from 'react';
import { useQuestionContext } from '../../../../../../sk-doc/src/QuestionContext';
import SKDoc from '../../../../../../sk-doc/src/SKDoc';
import {filter} from '../../../../../../sk-doc/src/utils/data';

const AnswerFilter: React.FC<{
  data: any;
  correctAnswer: any;
  isContainer?: boolean;
}> = ({ data, correctAnswer, isContainer = true }) => {
  const questionContext = useQuestionContext();

  useEffect(() => {
    if (!!data) {
      questionContext.fillExistingAnswer(correctAnswer);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);
  return (
    <div className={isContainer ? 'container' : ''} id="answerFilter">
      <SKDoc element={filter(data)} />
    </div>
  );
};

export default AnswerFilter;
